var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilverLiningBgTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1424,
    height: 222,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1105.42 1.12069C1105.42 122.296 963.411 220.529 788.24 220.529C613.07 220.529 471.065 122.296 471.065 1.12066",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.02 1.12034C1118.02 112.602 976.019 203.08 800.849 203.08C625.678 203.08 483.673 112.602 483.673 1.12031",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.63 1.12271C1130.63 102.91 988.63 185.633 813.459 185.633C638.288 185.633 496.283 102.91 496.283 1.12269",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.71 1.12141C1143.71 93.2149 1001.71 167.859 826.539 167.859C651.368 167.859 509.364 93.2148 509.364 1.12139",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.33 1.11755C1156.33 83.5169 1014.32 150.406 839.152 150.406C663.982 150.406 521.977 83.5169 521.977 1.11753",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.94 1.11847C1168.94 73.8238 1026.93 132.957 851.761 132.957C676.59 132.957 534.585 73.8238 534.585 1.11844",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.55 1.1217C1181.55 64.133 1039.55 115.188 864.377 115.188C689.206 115.188 546.734 64.133 546.734 1.12167",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.17 1.12168C1194.17 54.4389 1052.16 97.739 876.993 97.739C701.823 97.739 559.818 54.4389 559.818 1.12165",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.25 1.12168C1207.25 44.7449 1065.24 80.2897 890.069 80.2897C714.899 80.2897 572.894 44.7449 572.894 1.12166",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.86 1.11859C1219.86 35.0478 1077.85 62.5142 902.681 62.5142C727.51 62.5142 585.505 35.0477 585.505 1.11856",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1232.47 1.11686C1232.47 25.352 1090.46 45.0632 915.294 45.0632C740.123 45.0632 598.118 25.352 598.118 1.11683",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.08 1.12155C1245.08 15.6626 1103.08 27.6186 927.905 27.6186C752.735 27.6186 610.73 15.6626 610.73 1.12151",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M788.238 1.1173C788.238 122.293 930.243 220.526 1105.41 220.526C1280.58 220.526 1423.06 122.293 1423.06 1.11733",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M775.626 1.11753C775.626 112.599 917.631 203.077 1092.8 203.077C1267.97 203.077 1409.98 112.599 1409.98 1.11756",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M762.545 1.11814C762.545 102.906 904.55 185.628 1079.72 185.628C1254.89 185.628 1397.36 102.906 1397.36 1.11817",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M749.935 1.11617C749.935 93.2096 891.939 167.854 1067.11 167.854C1242.28 167.854 1384.75 93.2096 1384.75 1.11619",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M737.321 1.12052C737.321 83.5199 879.326 150.409 1054.5 150.409C1229.67 150.409 1372.14 83.5199 1372.14 1.12054",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M724.71 1.1167C724.71 73.822 866.715 132.956 1041.89 132.956C1217.06 132.956 1359.53 73.8221 1359.53 1.11673",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M712.097 1.11853C712.097 64.1298 854.102 115.185 1029.27 115.185C1204.44 115.185 1346.45 64.1299 1346.45 1.11856",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M699.017 1.11722C699.017 54.4345 841.022 97.7345 1016.19 97.7345C1191.36 97.7346 1333.83 54.4345 1333.83 1.11725",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M686.406 1.11668C686.405 44.7399 828.411 80.2847 1003.58 80.2847C1178.75 80.2848 1320.76 44.7399 1320.76 1.11671",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M673.795 1.1156C673.795 35.0448 815.8 62.5112 990.971 62.5112C1166.14 62.5113 1308.15 35.0448 1308.15 1.11563",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M661.182 1.11641C661.182 25.3515 803.187 45.0628 978.358 45.0628C1153.53 45.0628 1295.53 25.3516 1295.53 1.11643",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M648.569 1.11554C648.569 15.6566 790.574 27.6127 965.744 27.6127C1140.91 27.6127 1282.92 15.6566 1282.92 1.11556",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M635.955 1.11925C635.955 5.96627 777.96 9.84394 953.131 9.84395C1128.3 9.84396 1270.31 5.9663 1270.31 1.11927",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.7 1.11564C1257.7 5.96267 1115.7 9.84033 940.525 9.84032C819.54 9.84031 714.438 7.90142 660.719 5.31633",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M153.418 1.11199C153.418 122.288 295.423 220.521 470.594 220.521C645.764 220.521 787.77 122.288 787.77 1.11202",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M140.804 1.11613C140.804 112.598 282.809 203.075 457.979 203.075C633.15 203.075 775.622 112.598 775.622 1.11616",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M127.725 1.11265C127.725 102.9 269.73 185.623 444.9 185.623C620.071 185.623 762.076 102.9 762.076 1.11267",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M115.114 1.11055C115.114 93.204 257.119 167.848 432.289 167.848C607.46 167.848 749.465 93.204 749.465 1.11058",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M102.502 1.11521C102.502 83.5146 244.507 150.404 419.678 150.404C594.849 150.404 736.854 83.5146 736.854 1.11523",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M89.89 1.1113C89.89 73.8166 231.895 132.95 407.066 132.95C582.236 132.95 724.241 73.8167 724.241 1.11133",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2786 1.10898C77.2785 64.1203 219.284 115.176 394.454 115.176C569.625 115.176 711.63 64.1203 711.63 1.109",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6682 1.1113C64.6682 54.4286 206.673 97.7286 381.844 97.7286C557.014 97.7286 699.02 54.4286 699.02 1.11133",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5842 1.11226C51.5842 44.7355 193.589 80.2803 368.76 80.2803C543.93 80.2803 685.936 44.7355 685.936 1.11228",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9729 1.11166C38.9729 35.0408 180.978 62.5073 356.149 62.5073C531.319 62.5073 673.324 35.0409 673.324 1.11169",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3607 1.10829C26.3607 25.3434 168.366 45.0547 343.536 45.0547C518.707 45.0547 660.712 25.3434 660.712 1.10832",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7492 1.11065C13.7492 15.6517 155.754 27.6078 330.925 27.6078C506.096 27.6078 648.101 15.6518 648.101 1.11068",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1361 1.11409C1.1361 5.96112 143.141 9.83879 318.312 9.83879C493.482 9.8388 635.487 5.96114 635.487 1.11411",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M622.879 1.11247C622.879 5.9595 480.874 9.83715 305.703 9.83714C184.719 9.83714 79.6164 7.89825 25.8974 5.31316",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverLiningBgTop);
export default __webpack_public_path__ + "static/media/silver-lining-bg-top.aa8255d70dd21226365efb7c22a1d7dc.svg";
export { ForwardRef as ReactComponent };